import { render, staticRenderFns } from "./AskAdvice.vue?vue&type=template&id=3b2e5aa3&scoped=true&"
import script from "./AskAdvice.vue?vue&type=script&lang=ts&"
export * from "./AskAdvice.vue?vue&type=script&lang=ts&"
import style0 from "./AskAdvice.vue?vue&type=style&index=0&id=3b2e5aa3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2e5aa3",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsSocialMail: require('/var/www/packages/theme/components/icons/social/Mail.vue').default,IconsSocialStores: require('/var/www/packages/theme/components/icons/social/Stores.vue').default,IconsPhone: require('/var/www/packages/theme/components/icons/phone/Phone.vue').default,IconsSocialInstagram: require('/var/www/packages/theme/components/icons/social/Instagram.vue').default,IconsSocialFacebook: require('/var/www/packages/theme/components/icons/social/Facebook.vue').default,IconsSocialYoutube: require('/var/www/packages/theme/components/icons/social/Youtube.vue').default,IconsSocialTwitter: require('/var/www/packages/theme/components/icons/social/Twitter.vue').default,AtomsSocialContactButton: require('/var/www/packages/theme/components/atoms/SocialContactButton.vue').default})
